module.exports = __webpack_public_path__ + "static/img/design.2f34397a.png";